// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"589":"bb4071ce","814":"fba80d94","907":"b6fba90a"}[chunkId] + ".chunk.css";
};